import { call, put, take, fork, cancel, cancelled } from 'redux-saga/effects'
import { eventChannel } from 'redux-saga'
import firebase from 'firebase/app'

import MerchantRequestActions, { MerchantCloseRequestTypes } from '../reducers/merchantCloseRequestReducer'

const observer = ref => {
  const listener = eventChannel(emit => {
    const subscriber = ref.onSnapshot(
      querySnapshot => {
        const requests = []

        querySnapshot.forEach(doc => {
          requests.push({ ...doc.data(), doc_id: doc.id })
        })

        emit(requests)
      },
      err => {
        emit(new Error(err))
      }
    )

    return () => subscriber
  })
  return listener
}

export function* closeRequestObserver() {
  const ref = firebase
    .firestore()
    .collection('merchant_close_requests')
    .where('status', '==', 'pending')
    .orderBy('created_at', 'asc')

  const channel = yield call(observer, ref)
  try {
    while (true) {
      const snapshot = yield take(channel)

      yield put(MerchantRequestActions.setPendingRequests(snapshot))
    }
  } catch (err) {
    yield put(MerchantRequestActions.setPendingRequests([]))
  } finally {
    if (yield cancelled()) {
      channel.close()
    }
  }
}

export function* syncPendingRequests() {
  const closeRequestListener = yield fork(closeRequestObserver)

  yield take(MerchantCloseRequestTypes.UN_SYNC_PENDING_REQUESTS)
  yield cancel(closeRequestListener)
}



// WEBPACK FOOTER //
// ./src/sagas/merchantCloseRequestSaga.js